<template>
  <el-dialog
      :close-on-click-modal="false"
      title="备注"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
          @sub="sub"
          :noSubBtn="true"
          ref="customForm"
          :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  getOrderReamrkInfo,
  orderChangeRemark,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            placeholder: '请输入备注信息',
          },
          {
            label: '实际到达时间',
            value: 'actualArrivalTime',
            type: 'date',
            width: '240px',
            attr: {
              type: 'datetime',
              time: '00:00:00',
            },
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      const remarkRes = await getOrderReamrkInfo({
        orderId: item.orderId,
      });
      this.getDetailLoading = false;
      item.remark = remarkRes.remark;
      item.actualArrivalTime = remarkRes.actualArrivalTime;
      this.$refs.customForm.setVal(item);
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await orderChangeRemark({
        orderId: this.originData.orderId,
        remark: form.remark,
        actualArrivalTime: `${this.formatDate(form.actualArrivalTime, 1)}`,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
